import React, { useState } from "react";
import { Card, Col, Nav, Row, Tab } from "react-bootstrap";
import Flex from "../Flex"; 
const NavItem = ({ item, active }) => {
  const navLinkStyle = {
    cursor: "pointer",
    padding: "10px",
    border: "1px solid #F0F0F0",
    borderBottom: "none",
    backgroundColor: "#f1f1f1",
    borderRadius: "5px",
    transition: "background-color 0.1s ease",
  };

  const navLinkActiveStyle = {
   ...navLinkStyle,
    backgroundColor: "#F3F2F3",
    borderColor: "#F0F0F0",
    color: "white",
  };

  return (
    <Nav.Item as="li">
      <Nav.Link
        className="mb-0 py-3 cursor-pointer"
        eventKey={item.toLowerCase()}
        style={active? navLinkActiveStyle : navLinkStyle}
      >
        <span style={{ fontSize: 12 }} className="text-capitalize text-nowrap">
          {item}
        </span>
      </Nav.Link>
    </Nav.Item>
  );
};

const CardTabs = ({ components }) => {
  const [navItems] = useState(Object.keys(components));
  const [activeKey, setActiveKey] = useState(navItems[0]);

  const handleSelect = (key) => {
    setActiveKey(key);
  };

  return (
    <Card className="shadow px-1">
      <Tab.Container id="audience-tab" defaultActiveKey={activeKey} onSelect={handleSelect}>
        <Card.Header
          style={{ width: "100%", overflowX: "scroll", overflowY: "hidden" }}
          light
          as={Flex}
          justifyContent="space-between"
          alignItems="center"
          className="ps-0 py-2 scrollable-section"
        >
          <Nav
            as="ul"
            className="nav-tabs border-0 flex-nowrap chart-tab tab-active-caret mx-2 mb-n3"
            style={{
              cursor: "pointer",
              gap: "3px",
              border: "3px solid #F0F0F0",
              borderBottom: "none",
              backgroundColor: "#FAFAFA",
              paddingBottom: "-3px",
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center", 
            }}
          >
            {navItems.map((item) => (
              <NavItem item={item} key={item} active={activeKey === item.toLowerCase()} />
            ))}
          </Nav>
        </Card.Header>

        <Card.Body>
          <Row className="g-1">
            <Col>
              <Tab.Content>
                {Object.entries(components).map(([name, component]) => (
                  <Tab.Pane unmountOnExit eventKey={name} key={name}>
                    {component}
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Col>
          </Row>
        </Card.Body>
      </Tab.Container>
    </Card>
  );
};

export default CardTabs;
